import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'

import useFetch from 'shared/model/useFetch'
import useAlertModalAtom from 'shared/model/useAlertModalAtom'
import useRoleCookie from 'shared/model/useRoleCookie'
import getApiRolePath from 'shared/utils/getApiRolePath'

const useGetFranchiseManagerList = () => {
	const [userRole] = useRoleCookie()
	const [searchParams] = useSearchParams()
	const page = searchParams.get('page')
	const search = searchParams.get('search')

	const [fetchResult, fetchRequest, isLoading] = useFetch()
	const [, setAlert] = useAlertModalAtom()

	useEffect(() => {
		const rolePath = getApiRolePath(userRole)
		fetchRequest(
			'GET',
			`/${rolePath}/franchise/manager/list?page=${page}&search=${search || ''}`
		)
	}, [page, search])

	useEffect(() => {
		switch (fetchResult?.statusCode) {
			case 400:
				if (fetchResult?.data?.error_code === 'page')
					setAlert('페이지 번호 입력 양식을 확인해 주세요.')
				else if (fetchResult?.data?.error_code === 'search')
					setAlert('검색어 입력 양식을 확인해 주세요.')
				else setAlert('입력한 값의 형식이 잘못되었습니다.')
				break
		}
	}, [fetchResult])

	return [fetchResult, isLoading]
}

export default useGetFranchiseManagerList
